export default function About() {
  return (
    <section id="about" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          <div className="md:col-span-2 space-y-6">
            <div className="inline-block px-4 py-2 border-2 border-sky-500 rounded-lg">
              <span className="text-xs font-bold text-sky-500 tracking-wider">WHO WE ARE</span>
            </div>

            <h2 className="text-5xl font-bold leading-tight">
              <div className="text-gray-900">Prakash Electricals [OPK]</div>
              <div className="text-gray-500 font-semibold">Powering Progress Since Day One</div>
            </h2>

            <p className="text-gray-700 leading-relaxed">
              Prakash Electricals [OPK] is a professionally managed electrical contracting company led by Ajay Kumar, an experienced electrical contractor with a strong track record in delivering safe, efficient, and high-quality electrical solutions.
            </p>

            <p className="text-gray-700 leading-relaxed">
              We specialize in end-to-end electrical works, ranging from large-scale cable laying projects to household electrical installations and repairs. Our focus is on precision, safety compliance, timely execution, and long-term reliability.
            </p>

            <a href="#contact" className="inline-flex items-center text-sky-600 font-medium hover:text-sky-700 transition-colors cursor-pointer">
              Meet Our Founder
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>

          <div className="md:col-span-3 relative">
            <div className="flex justify-end gap-8 mb-8">
              <div className="text-right">
                <div className="text-6xl font-bold text-gray-900">500+</div>
                <div className="text-sm text-gray-600 mt-2">Projects Completed</div>
              </div>
              <div className="text-right">
                <div className="text-6xl font-bold text-gray-900">15+</div>
                <div className="text-sm text-gray-600 mt-2">Years Experience</div>
              </div>
            </div>

            <div className="relative">
              <div className="absolute top-0 left-0 w-80 h-80 z-20">
                <img
                  src="https://static.readdy.ai/image/fa99bb9c62df4d6cdaf96fd6599da80a/3b5080f2d6027d7b8f8e87c74ce67a16.jpeg"
                  alt="Ajay Kumar - Founder"
                  className="w-full h-full object-cover rounded-3xl shadow-xl"
                />
              </div>

              <div className="absolute bottom-0 right-0 w-96 h-[520px] z-10">
                <img
                  src="https://public.readdy.ai/ai/img_res/2544b280da8a433eeba29d9f488ed7dd.jpg"
                  alt="Team at Work"
                  className="w-full h-full object-cover rounded-3xl shadow-xl"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-24 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-sky-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-shield-check-line text-2xl text-sky-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Experienced & Skilled Workforce</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Our team comprises highly trained professionals with years of hands-on experience in electrical contracting.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-sky-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-award-line text-2xl text-sky-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Quality Materials & Standards</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              We use only premium quality materials and follow industry-standard practices for all installations.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-sky-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-time-line text-2xl text-sky-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Timely Project Completion</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              We pride ourselves on delivering projects on schedule without compromising on quality or safety.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-sky-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-shield-star-line text-2xl text-sky-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Safety-First Approach</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Safety is our top priority. We implement strict safety protocols on every project site.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-sky-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-price-tag-3-line text-2xl text-sky-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Transparent Pricing</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              No hidden costs. We provide clear, upfront pricing for all our services and projects.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-sky-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-star-line text-2xl text-sky-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Trusted by Reputed Companies</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Our track record speaks for itself with successful projects for leading organizations.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
